import { ICcypair } from '@alk/currency';
import { IInstrument } from '../interfaces/instrument.interface';

export const DATA_00: IInstrument = {
    symbol: 'EURUSD' as ICcypair,
    fractionSize: 5,
    minTradeQty: 100000,
    roundLot: 1000,
    extraDigital: true,
    holidays: [],
    settlementPeriod: 2,
    productType: 'spot',
    quotesTrendOnly: false,
};

export const DATA_01: IInstrument = {
    symbol: 'EURUSD' as ICcypair,
    fractionSize: 5,
    minTradeQty: 100000,
    roundLot: 1000,
    extraDigital: true,
    holidays: [],
    settlementPeriod: 2,
    productType: 'forward',
};

export const DATA_02: IInstrument = {
    symbol: 'EURGBP' as ICcypair,
    fractionSize: 5,
    minTradeQty: 1000000,
    roundLot: 10000,
    extraDigital: true,
    holidays: [],
    settlementPeriod: 2,
    productType: 'spot',
    quotesTrendOnly: true,
};

export const DATA_03: IInstrument = {
    symbol: 'USDJPY' as ICcypair,
    fractionSize: 2,
    minTradeQty: 1000000,
    roundLot: 10000,
    extraDigital: true,
    holidays: [],
    settlementPeriod: 2,
    productType: 'spot',
};

export const DATA_02_F: IInstrument = {
    symbol: 'EURGBP' as ICcypair,
    fractionSize: 5,
    minTradeQty: 1000000,
    roundLot: 10000,
    extraDigital: true,
    holidays: [],
    settlementPeriod: 2,
    productType: 'forward',
};

export const DATA_03_F: IInstrument = {
    symbol: 'USDJPY' as ICcypair,
    fractionSize: 2,
    minTradeQty: 1000000,
    roundLot: 10000,
    extraDigital: true,
    holidays: [],
    settlementPeriod: 2,
    productType: 'forward',
};

export const DATA_04: IInstrument = {
    symbol: 'USDRUB' as ICcypair,
    fractionSize: 4,
    minTradeQty: 1000000,
    roundLot: 1000,
    extraDigital: true,
    holidays: [],
    settlementPeriod: 2,
    productType: 'forward',
};

export const DATA_05: IInstrument = {
    symbol: 'CHFNOK' as ICcypair,
    fractionSize: 4,
    minTradeQty: 1000000,
    roundLot: 1000,
    extraDigital: true,
    holidays: [],
    settlementPeriod: 2,
    productType: 'forward',
};

export const DATA_06: IInstrument = {
    symbol: '100GBP' as ICcypair,
    fractionSize: 4,
    minTradeQty: 1000000,
    roundLot: 1000,
    extraDigital: true,
    holidays: [],
    settlementPeriod: 2,
    productType: 'forward',
};

export const DATA_07: IInstrument = {
    symbol: '100GBP' as ICcypair,
    fractionSize: 4,
    minTradeQty: 1000000,
    roundLot: 1000,
    extraDigital: true,
    holidays: [],
    settlementPeriod: 2,
    productType: 'spot',
    quotesTrendOnly: true,
};

export const DATA_08: IInstrument = {
    symbol: 'USDVND' as ICcypair,
    fractionSize: 0,
    minTradeQty: 1000000,
    roundLot: 1000,
    extraDigital: true,
    holidays: [],
    settlementPeriod: 2,
    productType: 'spot',
};

export const ARRAY_OF_INSTRUMENTS_01 = [
    DATA_00,
    DATA_01,
    DATA_02,
    DATA_02_F,
    DATA_03,
    DATA_03_F,
    DATA_04,
    DATA_05,
    DATA_06,
    DATA_07,
    DATA_08,
];
export const ARRAY_OF_INSTRUMENTS_02 = [ DATA_01, DATA_06 ];
export const ARRAY_OF_INSTRUMENTS_03 = [ DATA_00, DATA_02, DATA_03, DATA_06 ];

export const ARRAY_OF_INSTRUMENTS_FOR_SPOT_01 =
    ARRAY_OF_INSTRUMENTS_01.filter(item => item.productType === 'spot');
export const ARRAY_OF_INSTRUMENTS_FOR_FORWARD_01 =
    ARRAY_OF_INSTRUMENTS_01.filter(item => item.productType === 'forward');
